<!-- langugage Dropdown -->
<button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5" matTooltip="{{ 'ChangeLanguage' | translate}}">
   <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
</button>
<mat-menu #flags="matMenu" class="cardWithShadow">
   @for(lang of languages; track lang.icon) {
   <button mat-menu-item (click)="onChangeLanguage(lang)">
      <div class="d-flex align-items-center">
         <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
         <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
      </div>
   </button>
   }
</mat-menu>
